import React from "react";
import { useSite } from "../context/SiteContext";

export const Logo = ({ size = 36 }) => {
  const { img } = useSite();
  const customLogo = img("header_logo", "");

  if (customLogo) {
    return (
      <img
        src={customLogo}
        alt="Kultopia"
        style={{ height: size, width: "auto", display: "block" }}
        className="select-none"
        data-testid="kult-logo-img"
      />
    );
  }

  return (
    <span
      className="inline-flex items-center font-display select-none"
      style={{ fontSize: size, lineHeight: 1 }}
      data-testid="kult-logo"
    >
      <span style={{ color: "#ff007f" }}>KULT</span>
      <span
        aria-hidden
        style={{
          display: "inline-block",
          width: "0.18em",
          height: "1em",
          marginLeft: "-0.04em",
          marginRight: "-0.04em",
          background: "#eaff00",
          transform: "skewX(-20deg)",
          clipPath:
            "polygon(50% 0, 100% 35%, 60% 45%, 90% 55%, 30% 100%, 50% 60%, 10% 50%, 40% 40%)",
        }}
      />
      <span style={{ color: "#ff007f" }}>PIA</span>
    </span>
  );
};
